import React from "react";
import ReactDOM from "react-dom";
// import Preloader from "./components/Preloader/Preloader";

import "./styles.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>
          Website Is Coming Soon
        </h1>
        {/* <Preloader /> */}
      </div>
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
